








































import { defineComponent } from '@vue/composition-api';
import { t } from '@getaccept/lib-shared/src/helpers/translation.helper';
import { ButtonType, RainbowColor, ModalSize } from '@getaccept/lib-ui';
import { useIntercomChat } from '@getaccept/lib-shared/src/composables/intercom-chat.composable';
import PlansInformation from './PlansInformation.vue';

export default defineComponent({
  components: { PlansInformation },
  setup(_, { emit }) {
    const { openChat: openIntercomChat } = useIntercomChat();

    const openChat = () => {
      openIntercomChat();
      emit('close');
    };

    return {
      RainbowColor,
      t,
      openChat,
      ButtonType,
      ModalSize,
    };
  },
});
